module.exports = __webpack_public_path__ + "img/uk-flag.e9bd0fae.svg";